// extracted by mini-css-extract-plugin
module.exports = {"title":"contract_title__2vFLw","agreementbox":"contract_agreementbox__r5RC7"};